import { installCryptoRandomUUID } from './crypto-random-uuid';
// Side-effect entry point: importing '@applyonline/shared/polyfills' applies these.
installCryptoRandomUUID();
export { installCryptoRandomUUID };
